type YearActivityGridDay = {
  date: string | null;
};

export type YearActivityGridWeek = {
  weekMonday: string;
  days: YearActivityGridDay[];
};

export function addUtcDays(dateStr: string, delta: number): string {
  const [y, m, d] = dateStr.split("-").map(Number);
  const next = new Date(Date.UTC(y, m - 1, d + delta));
  return next.toISOString().slice(0, 10);
}

function utcDayOfWeek(dateStr: string): number {
  return new Date(`${dateStr}T00:00:00Z`).getUTCDay();
}

function daysFromUtcMonday(dateStr: string): number {
  return (utcDayOfWeek(dateStr) + 6) % 7;
}

export function utcMondayOnOrBefore(dateStr: string): string {
  return addUtcDays(dateStr, -daysFromUtcMonday(dateStr));
}

export function buildYearActivityWeeks({
  endDateStr,
}: {
  endDateStr: string;
}): YearActivityGridWeek[] {
  const windowStart = addUtcDays(endDateStr, -364);
  const windowStartMonday = utcMondayOnOrBefore(windowStart);
  const weekEndSunday = addUtcDays(utcMondayOnOrBefore(endDateStr), 6);

  const weeks: YearActivityGridWeek[] = [];
  let weekMonday = windowStartMonday;
  while (weekMonday <= weekEndSunday) {
    const days: YearActivityGridDay[] = [];
    for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
      const date = addUtcDays(weekMonday, dayIndex);
      const inWindow = date >= windowStart && date <= endDateStr;
      days.push({ date: inWindow ? date : null });
    }
    weeks.push({ weekMonday, days });
    weekMonday = addUtcDays(weekMonday, 7);
  }
  return weeks.filter((week) => week.days.some((day) => day.date !== null));
}

export function mapIdsForYearWindow({ endDateStr }: { endDateStr: string }): string[] {
  const windowStart = addUtcDays(endDateStr, -364);
  const ids: string[] = [];
  let current = windowStart;
  while (current <= endDateStr) {
    ids.push(`${current}-standard`, `${current}-premium`);
    current = addUtcDays(current, 1);
  }
  return ids;
}
